module.exports = __webpack_public_path__ + "static/img/tst2-05-1.f7f5365.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-05-1.gif
// module id = 1XcU
// module chunks = 1